/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-13 10:49:55
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-18 17:25:08
 */
import { createSlice } from "@reduxjs/toolkit";
import { api } from "../.././app/applicationSlice";
import { RootState, RootThunk } from "../../app/store"
import { durgSalesPage, DurgSalesParams } from "../../services/durgSales";

const initialState = {
    DurgSalesData: [],
    DurgSalesTotal: 0,
    DurgSalesCurrent: 1,
    otcTag: undefined,
    materialsCategory: undefined,
}

export const DurgSalesSlice = createSlice({
    name: "DurgSales",
    initialState,
    reducers: {
        setDurgSaleData(state, action) {
            state.DurgSalesData = action.payload
        },
        setDurgSaleTotal(state, action) {
            state.DurgSalesTotal = action.payload
        },
        setDurgSaleCurrent(state, action) {
            state.DurgSalesCurrent = action.payload
        },
        setotcTag(state, action) {
            state.otcTag = action.payload
        },
        setmaterialsCategory(state, action) {
            state.materialsCategory = action.payload
        },
    }
})

export const { setDurgSaleData, setDurgSaleCurrent, setDurgSaleTotal, setotcTag, setmaterialsCategory } = DurgSalesSlice.actions

export function getDurgsales(params: DurgSalesParams): RootThunk {
    return api(durgSalesPage(params), (data: any, dispatch) => {
        dispatch(setDurgSaleData(data.records))
        dispatch(setDurgSaleTotal(data.total))
    })
}

export const selectDurgSalesData = (state: RootState) => state.DurgSales.DurgSalesData

export const selectDurgSalesTotal = (state: RootState) => state.DurgSales.DurgSalesTotal

export const selectDurgSalesCurrent = (state: RootState) => state.DurgSales.DurgSalesCurrent

export const selectOtctag = (state: RootState) => state.DurgSales.otcTag

export const selectmaterialsCategory = (state: RootState) => state.DurgSales.materialsCategory

export default DurgSalesSlice.reducer